import type { Lang, Namespace } from './parts/types';
export type { Lang } from './parts/types';
interface Part {
  zh: Namespace;
  en: Namespace;
}
function isPart(mod: unknown): mod is Part {
  return (
    typeof mod === 'object' &&
    mod !== null &&
    'zh' in mod &&
    'en' in mod &&
    typeof (mod as { zh: unknown }).zh === 'object' &&
    typeof (mod as { en: unknown }).en === 'object'
  );
}
function merge(lang: 'zh' | 'en'): Namespace {
  const mods = import.meta.glob<Part>('./parts/*.ts', { eager: true });
  const out: Record<string, Namespace> = {};
  const owner = new Map<string, string>();
  for (const path of Object.keys(mods).sort()) {
    const mod: unknown = mods[path];
    if (!isPart(mod)) continue;
    const namespaces = mod[lang];
    for (const key of Object.keys(namespaces)) {
      const prev = owner.get(key);
      if (prev !== undefined) {
        throw new Error(
          `locales: 命名空间「${key}」被两个分片同时声明（${prev} 与 ${path}）。` +
            '命名空间必须一域一个；要共用词条请放进 common.ts。',
        );
      }
      const ns = namespaces[key];
      if (typeof ns !== 'object' || ns === null) {
        throw new Error(`locales: ${path} 的顶层键「${key}」不是命名空间对象。`);
      }
      owner.set(key, path);
      out[key] = ns;
    }
  }
  return out;
}
const zhCN = merge('zh');
const enUS = merge('en');
export const DEFAULT_LANG: Lang = 'zh-CN';
export const LANGS: readonly Lang[] = ['zh-CN', 'en-US'];
export const resources = {
  'zh-CN': { translation: zhCN },
  'en-US': { translation: enUS },
} as const;
export function isLang(value: string): value is Lang {
  return (LANGS as readonly string[]).includes(value);
}
